import { useTranslation } from 'react-i18next'
import appPhoneCs from '../../assets/img/app-phone-cs.png'
import appPhoneEn from '../../assets/img/app-phone-en.png'
import appPhoneUk from '../../assets/img/app-phone-uk.png'
import { ButtonLocation } from '../../utils/analyticsEvents'
import { Icon } from '../Icon/Icon'
import { LocalizedImage } from '../LocalizedImage/LocalizedImage'
import { StoreButtons } from '../StoreButtons/StoreButtons'
import styles from './AppSection.module.scss'

const INSTRUCTION_KEYS = ['create', 'choose', 'drop', 'track']

const APP_PHONE_SOURCES = { cs: appPhoneCs, en: appPhoneEn, uk: appPhoneUk }

export const AppSection = () => {
  const { t } = useTranslation()

  return (
    <section className={styles.section} id="easy-sending">
      <div className={`container ${styles.inner}`}>
        <div className={styles.media}>
          <LocalizedImage
            alt={t('app.imageAlt')}
            className={styles.image}
            height="3248"
            loading="lazy"
            sources={APP_PHONE_SOURCES}
            width="1500"
          />
        </div>
        <div>
          <h2 className={styles.title}>{t('app.title')}</h2>
          <p className={styles.subtitle}>{t('app.subtitle')}</p>
          <ul className={styles.list}>
            {INSTRUCTION_KEYS.map((key) => (
              <li key={key} className={styles.item}>
                <Icon className={styles.icon} name="check-circle" size={24} />
                <span>{t(`app.items.${key}`)}</span>
              </li>
            ))}
          </ul>
          <StoreButtons className={styles.stores} location={ButtonLocation.EasySending} />
        </div>
      </div>
    </section>
  )
}
